import React from 'react'
import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { useToast } from '@wartek-id/toast'

import { SocialShareDrawer } from 'components/SocialShareDrawer'
import AndroidHandler from 'utils/androidHandler'
import { generateDownloadFile } from 'utils/download'
import {
  SHARE_TEXT,
  DOWNLOAD_TOAST_MESSAGE,
} from 'app/DocumentCollectionPage/constants'
import { useSETrackEvent } from 'app/DocumentCollectionPage/hooks/useSETrackEvent'

import type { TDocument } from 'types/document-collection'

interface IDocumentActionFooterProps {
  data: TDocument
}

const DocumentActionFooter: React.FC<IDocumentActionFooterProps> = ({
  data,
}) => {
  const router = useRouter()
  const androidHandler = AndroidHandler()
  const toast = useToast()
  const { SETrackDocumentLandingPage } = useSETrackEvent()

  const [socialShareDrawerOpen, setSocialShareDrawerOpen] =
    React.useState<boolean>(false)

  const shareUrl = React.useMemo(
    () => `${process.env.NEXT_PUBLIC_BASE_URL}/dokumen/${data?.id}`,
    [data?.id]
  )

  const shareHandler = () => {
    SETrackDocumentLandingPage('CLICK_KUMPULAN_DOKUMEN_SHARE', {
      screen_name: 'KUMPULAN_DOKUMEN_DOCUMENT_PAGE',
      event_trigger: 'KUMPULAN_DOKUMEN_DOCUMENT_PAGE',
      parent_category: router?.query?.parentCategory,
      category: data?.categoryName,
      title: data?.title,
      content_id: data?.id,
      url: shareUrl,
    })
    if (androidHandler.enabled) {
      androidHandler.shareToolkitUrl(`${SHARE_TEXT} ${shareUrl}`)
    } else {
      setSocialShareDrawerOpen(true)
    }
  }

  const downloadHandler = () => {
    const categoryName = data?.categoryName ?? ''
    const documentUrl = data?.documentUrl ?? ''
    const documentName = documentUrl.substring(documentUrl.lastIndexOf('/') + 1)

    if (!Boolean(documentUrl)) {
      return
    }

    SETrackDocumentLandingPage('CLICK_KUMPULAN_DOKUMEN_DOWNLOAD', {
      screen_name: 'KUMPULAN_DOKUMEN_DOCUMENT_PAGE',
      event_trigger: 'KUMPULAN_DOKUMEN_DOCUMENT_PAGE',
      parent_category: router?.query?.parentCategory,
      category: data?.categoryName,
      title: data?.title,
      content_id: data?.id,
      url: documentUrl,
    })

    try {
      if (
        androidHandler.enabled &&
        typeof window.AndroidHandler?.downloadCollection === 'function'
      ) {
        androidHandler.downloadCollection({
          path: `${categoryName}/`,
          url: documentUrl,
          toast: DOWNLOAD_TOAST_MESSAGE,
        })
      } else {
        generateDownloadFile(data?.documentUrl, documentName)
        toast({
          message: DOWNLOAD_TOAST_MESSAGE,
        })
      }
    } catch (e) {}
  }

  return (
    <>
      <div className="max-w-xl mx-auto fixed bottom-0 left-0 right-0 p-4 space-y-4 bg-white shadow-[inset_0px_5px_3px_-3px_rgba(0,0,0,0.08)]">
        <div className="flex justify-around space-x-2">
          <Button color="white" fullWidth onClick={shareHandler}>
            <Icon>share</Icon>&nbsp;Bagikan
          </Button>
          <Button color="blue" fullWidth onClick={downloadHandler}>
            <Icon color="inverse">download</Icon>&nbsp;Unduh
          </Button>
        </div>
      </div>

      {socialShareDrawerOpen && (
        <SocialShareDrawer
          isOpen={socialShareDrawerOpen}
          onClose={() => {
            setSocialShareDrawerOpen(false)
          }}
          shareUrl={shareUrl}
          shareText={SHARE_TEXT}
        />
      )}
    </>
  )
}

export default DocumentActionFooter
